import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const createSystemUserPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'system', 'portal_users.create');
